import WmsLayer from './WmsLayer';

export default class PogLayer extends WmsLayer {
    static ID = 'pog';
    static DESCRIPTION = 'Plan ogólny gminy (Rejestr Urbanistyczny)';
    static MIN_ZOOM = 12;
    static WMS_URL = 'https://rejestr-urbanistyczny.gov.pl/uslugi-sieciowe/wms-pog/ows';

    static LAYERS = [
        'APP.POG.PrawnieWiazacyLubRealizowany',
        'APP.POG.WTrakciePrzyjmowania',
        'APP.POG.WOpracowaniu',
        'APP.POG.ObszarZabudowySrodmiejskiej.PrawnieWiazacyLubRealizowany',
        'APP.POG.ObszarZabudowySrodmiejskiej.WTrakciePrzyjmowania',
        'APP.POG.ObszarZabudowySrodmiejskiej.WOpracowaniu',
        'APP.POG.ObszarUzupelnieniaZabudowy.PrawnieWiazacyLubRealizowany',
        'APP.POG.ObszarUzupelnieniaZabudowy.WTrakciePrzyjmowania',
        'APP.POG.ObszarUzupelnieniaZabudowy.WOpracowaniu',
        'APP.POG.ObszarStandardowDostepnosciInfrastrukturySpolecznej.PrawnieWiazacyLubRealizowany',
        'APP.POG.ObszarStandardowDostepnosciInfrastrukturySpolecznej.WTrakciePrzyjmowania',
        'APP.POG.ObszarStandardowDostepnosciInfrastrukturySpolecznej.WOpracowaniu',
        'APP.POG.SW.PrawnieWiazacyLubRealizowany',
        'APP.POG.SJ.PrawnieWiazacyLubRealizowany',
        'APP.POG.SZ.PrawnieWiazacyLubRealizowany',
        'APP.POG.SU.PrawnieWiazacyLubRealizowany',
        'APP.POG.SH.PrawnieWiazacyLubRealizowany',
        'APP.POG.SP.PrawnieWiazacyLubRealizowany',
        'APP.POG.SR.PrawnieWiazacyLubRealizowany',
        'APP.POG.SI.PrawnieWiazacyLubRealizowany',
        'APP.POG.SN.PrawnieWiazacyLubRealizowany',
        'APP.POG.SC.PrawnieWiazacyLubRealizowany',
        'APP.POG.SG.PrawnieWiazacyLubRealizowany',
        'APP.POG.SO.PrawnieWiazacyLubRealizowany',
        'APP.POG.SK.PrawnieWiazacyLubRealizowany',
        'APP.POG.SW.WTrakciePrzyjmowania',
        'APP.POG.SJ.WTrakciePrzyjmowania',
        'APP.POG.SZ.WTrakciePrzyjmowania',
        'APP.POG.SU.WTrakciePrzyjmowania',
        'APP.POG.SH.WTrakciePrzyjmowania',
        'APP.POG.SP.WTrakciePrzyjmowania',
        'APP.POG.SR.WTrakciePrzyjmowania',
        'APP.POG.SI.WTrakciePrzyjmowania',
        'APP.POG.SN.WTrakciePrzyjmowania',
        'APP.POG.SC.WTrakciePrzyjmowania',
        'APP.POG.SG.WTrakciePrzyjmowania',
        'APP.POG.SO.WTrakciePrzyjmowania',
        'APP.POG.SK.WTrakciePrzyjmowania',
        'APP.POG.SW.WOpracowaniu',
        'APP.POG.SJ.WOpracowaniu',
        'APP.POG.SZ.WOpracowaniu',
        'APP.POG.SU.WOpracowaniu',
        'APP.POG.SH.WOpracowaniu',
        'APP.POG.SP.WOpracowaniu',
        'APP.POG.SR.WOpracowaniu',
        'APP.POG.SI.WOpracowaniu',
        'APP.POG.SN.WOpracowaniu',
        'APP.POG.SC.WOpracowaniu',
        'APP.POG.SG.WOpracowaniu',
        'APP.POG.SO.WOpracowaniu',
        'APP.POG.SK.WOpracowaniu'
    ];

    getWmsConfig() {
        return {
            url: PogLayer.WMS_URL,
            params: {
                LAYERS: PogLayer.LAYERS.join(','),
                FORMAT: 'image/png',
                TRANSPARENT: 'true',
                VERSION: '1.3.0'
            },
            opacity: 0.58,
            attribution: '&copy; <a href="https://rejestr-urbanistyczny.gov.pl/">Rejestr urbanistyczny</a> — plan ogólny gminy'
        };
    }
}
